import React from 'react'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'

import { signin, signup } from '../api/auth'
import { useError } from '../utils'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

const Auth = () => {
  const [ isSignIn, setIsSignIn ] = React.useState(true)
  const classes = useStyles()

  const { error, setError } = useError()
  const [ email, setEmail ] = React.useState('')
  const [ password, setPassword ] = React.useState('')

  React.useEffect(() => {
    setError('')
  }, [ isSignIn, setError ])

  const onSubmit = async (event) => {
    event.preventDefault()
    try {
      await (isSignIn ? signin : signup)(email, password)
    } catch(e) {
      setError(e)
    }
  }

  return (
    <Container component='main' maxWidth='xs'>
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          {isSignIn ? <LockOutlinedIcon /> : <PersonAddIcon />}
        </Avatar>
        <Typography component='h1' variant='h5'>
          {isSignIn ? 'Log In' : 'Register'}
        </Typography>
        <form className={classes.form} noValidate onSubmit={onSubmit}>
          <TextField
            variant='outlined'
            margin='normal'
            required
            fullWidth
            id='email'
            label='Email Address'
            name='email'
            autoComplete='email'
            autoFocus
            value={email}
            onChange={({ target }) => {
              setEmail(target.value)
            }}
          />
          <TextField
            variant='outlined'
            margin='normal'
            required
            fullWidth
            name='password'
            label='Password'
            type='password'
            id='password'
            autoComplete='current-password'
            value={password}
            onChange={({ target }) => {
              setPassword(target.value)
            }}
          />
          {error}
          <Button
            type='submit'
            fullWidth
            variant='contained'
            color='primary'
            className={classes.submit}
          >
            {isSignIn ? 'Log In' : 'Register'}
          </Button>
          <Grid container justify='flex-end'>
            {/* <Grid item xs>
              <Link to='/forgot-password' variant='body2'>
                Forgot password?
              </Link>
            </Grid> */}
            <Grid item>
              <div css={`cursor: pointer; text-decoration: underline;`} onClick={() => {
                setIsSignIn(!isSignIn)
              }}>
                {isSignIn ?
                  'Don\'t have an account? Create one!'
                  :
                  'Already have an account? Log in'
                }
              </div>
            </Grid>
          </Grid>
        </form>
      </div>
    </Container>
  )
}

export default Auth
